(() => {
  if (window.nsCollectionFiltersLoaded) return;
  window.nsCollectionFiltersLoaded = true;
  const init = (root = document) => root.querySelectorAll('[data-ns-filters]').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const groups = [...form.querySelectorAll('details')];
    const toggle = form.querySelector('[data-filter-toggle]');
    const close = (except) => groups.forEach(group => { if (group !== except) group.open = false; });
    const position = group => {
      const panel = group.querySelector('.ns-collection__filter-panel');
      panel.style.left = '';
      if (matchMedia('(min-width:750px)').matches) {
        const box = panel.getBoundingClientRect();
        if (box.right > innerWidth - 20) panel.style.left = `${Math.min(0, innerWidth - 20 - box.right)}px`;
      }
    };
    if (toggle) {
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.querySelector('[data-toggle-label]').textContent = expanded ? 'Hide filters' : 'Show filters';
        form.querySelector('.ns-collection__filters').hidden = !expanded;
        close();
      });
    }
    groups.forEach(group => {
      const update = () => {
        if (!group.querySelector('[data-selected-count]')) return;
        const count = group.querySelectorAll('input:checked').length;
        group.querySelector('[data-selected-count]').textContent = count;
        const badge = group.querySelector('[data-filter-badge]');
        badge.textContent = count;
        badge.hidden = count === 0;
      };
      group.addEventListener('toggle', () => { if (group.open) { close(group); position(group); } });
      group.addEventListener('change', update);
      const reset = group.querySelector('[data-filter-reset]');
      if (reset) { reset.hidden = false;
      reset.addEventListener('click', () => { group.querySelectorAll('input').forEach(input => { input.checked = false; }); update(); }); }
    });
    form.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const open = groups.find(group => group.open);
        if (open) { event.preventDefault(); close(); open.querySelector('summary').focus(); }
      }
    });
    document.addEventListener('click', event => {
      if (!form.isConnected) return;
      groups.forEach(group => { if (!group.contains(event.target)) group.open = false; });
    });
    window.addEventListener('resize', () => groups.forEach(group => { if (group.open) position(group); }));
    const sort = form.querySelector('[data-sort-dropdown]');
    if (sort && form.requestSubmit) {
      form.querySelector('[data-sort-apply]').hidden = true;
      sort.addEventListener('change', event => {
        if (event.target.name !== 'sort_by') return;
        sort.querySelector('[data-sort-label]').textContent = event.target.nextElementSibling.textContent;
        form.requestSubmit();
      });
    }
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
